import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlideIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z",
		fill: "#003B6F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.59 16.59L18.17 12L13.59 7.41L15 6L21 12L15 18L13.59 16.59Z",
		fill: "#003B6F"
	})]
});
export default SvgSlideIcon;
